import reducer from "./reducers";
import * as rootReducerOperations from "./operations";
export { rootReducerOperations };

export default reducer;
